import { PROBLEM_TYPE_META } from "@/lib/constants";
import { Check } from "lucide-react";

export default function ProblemTypeSelector({ types, value, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {types.map((t) => {
        const meta = PROBLEM_TYPE_META[t.id] || {};
        const Icon = meta.icon;
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            data-testid={`problem-type-${t.id}`}
            aria-pressed={active}
            className={`group text-left rounded-2xl p-6 border transition-[background-color,border-color,transform] duration-200 will-change-transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#35D07F]/60 ${
              active
                ? "bg-[#12181A] border-[#35D07F]"
                : "bg-[#12181A] border-white/10 hover:border-white/25"
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                {Icon ? (
                  <span
                    className={`inline-flex h-10 w-10 items-center justify-center rounded-xl border ${
                      active
                        ? "bg-[#35D07F]/10 border-[#35D07F]/50 text-[#35D07F]"
                        : "bg-white/5 border-white/10 text-white"
                    }`}
                  >
                    <Icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                ) : null}
                <div className="text-white font-semibold text-lg tracking-tight">
                  {t.display_name}
                </div>
              </div>
              {active && (
                <span
                  data-testid={`problem-type-${t.id}-selected`}
                  className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#35D07F] text-black"
                >
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
              )}
            </div>
            <p className="mt-4 text-sm text-[#A0AAB2] leading-relaxed">
              {meta.tagline}
            </p>
            {t.status !== "validated" && (
              <div className="mt-4 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-[#A0AAB2]">
                <span className="h-1 w-1 rounded-full bg-[#A0AAB2]" />
                beta baseline
              </div>
            )}
            {t.status === "validated" && (
              <div className="mt-4 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-[#35D07F]">
                <span className="h-1 w-1 rounded-full bg-[#35D07F]" />
                validated
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
